import Vue from 'vue';
import { adductionToStep } from '@/components/pages/spotPage/trade/helpers';
import { toNonExponential } from '@/utils/numbers';
export const tradeDataCommonFilters = Vue.extend({
    filters: {
        adductionToStep: adductionToStep,
        toNonExponential: toNonExponential
    }
});
